var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75002 2.66602H12.75V5.33268H6.08335V26.666H12.75V29.3327H4.75002C4.01364 29.3327 3.41669 28.7357 3.41669 27.9993V3.99935C3.41669 3.26297 4.01364 2.66602 4.75002 2.66602ZM27.4167 26.666H20.75V29.3327H28.75C29.4864 29.3327 30.0834 28.7357 30.0834 27.9993V3.99935C30.0834 3.26297 29.4864 2.66602 28.75 2.66602H20.75V5.33268H27.4167V26.666ZM15.4167 2.66602V3.99935L18.0834 3.99935V2.66602H15.4167ZM15.4167 6.66602V9.33268H18.0834V6.66602H15.4167ZM15.4167 11.9993V14.666H18.0834V11.9993H15.4167ZM15.4167 17.3327V19.9993H18.0834V17.3327H15.4167ZM15.4167 22.666V25.3327H18.0834V22.666H15.4167ZM15.4167 27.9993V29.3327H18.0834V27.9993H15.4167Z",
    fill: "#696F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitGrey);
export default __webpack_public_path__ + "static/media/split-grey.75ac36b6e996048a4d2a01bf98de53fe.svg";
export { ForwardRef as ReactComponent };